/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  SettingsState,
  SettingsActionTypes,
  GetSalesByKioskRequest,
  GetSalesByKioskPending,
  GetSalesByKioskSuccess,
  GetSalesByKioskError,
  SetConfigurationId
} from './types';

// Actions
export const actions = {
  getSalesByKiosk: (payload: GetSalesByKioskRequest['payload']): SettingsActionTypes => ({
    type: types.GET_SALES_BY_KIOSK.REQUEST,
    payload
  }),
  setConfigurationId: (payload: string): SettingsActionTypes => ({ type: types.SET_CONFIGURATION_ID, payload }),
  resetAction: (): SettingsActionTypes => ({ type: types.RESET_ACTION }),
  resetSalesByKiosk: (): SettingsActionTypes => ({ type: types.RESET_SALES_BY_KIOSK })
};

// Initial State
export const initialState: SettingsState = {
  configurationId: '',
  salesByKiosk: null,
  action: {
    success: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (state: SettingsState = initialState, action: SettingsActionTypes): SettingsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_SALES_BY_KIOSK.PENDING:
        draft.action.pending = (action as GetSalesByKioskPending).payload;
        break;
      case types.GET_SALES_BY_KIOSK.SUCCESS:
        draft.salesByKiosk = (action as GetSalesByKioskSuccess).payload;
        break;
      case types.GET_SALES_BY_KIOSK.ERROR:
        draft.action.error = (action as GetSalesByKioskError).payload;
        break;
      case types.SET_CONFIGURATION_ID:
        draft.configurationId = (action as SetConfigurationId).payload;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
      case types.RESET_SALES_BY_KIOSK:
        draft.salesByKiosk = initialState.salesByKiosk;
        break;
    }
  });
};
